module.exports = __webpack_public_path__ + "static/media/w-2_30.bcdb91d6.png";